/* Sweetwater Lane — infinite scroll for collection pages (replaces numbered pagination) */
(function () {
  function init() {
    var grid = document.getElementById('product-grid');
    if (!grid) return;
    var wrapper = document.querySelector('.pagination-wrapper');
    function getNext() {
      var a = document.querySelector('.pagination__item--next');
      return (a && a.href) ? a.href : null;
    }
    var url = getNext();
    if (wrapper) wrapper.style.display = 'none';
    if (!url) return;
    var loading = false, done = false;
    function maybeLoad() {
      if (loading || done) return;
      if ((window.innerHeight + window.scrollY) < (document.body.offsetHeight - 1400)) return;
      loading = true;
      fetch(url).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');
        if (newGrid) {
          Array.prototype.slice.call(newGrid.children).forEach(function (li) { grid.appendChild(li.cloneNode(true)); });
        }
        var na = doc.querySelector('.pagination__item--next');
        if (na && na.href) { url = na.href; loading = false; setTimeout(maybeLoad, 200); }
        else { done = true; }
      }).catch(function () { loading = false; });
    }
    window.addEventListener('scroll', maybeLoad, { passive: true });
    window.addEventListener('resize', maybeLoad, { passive: true });
    maybeLoad();
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
